import { render, staticRenderFns } from "./ExportModalFarmer.vue?vue&type=template&id=28c43386"
import script from "./ExportModalFarmer.vue?vue&type=script&lang=js"
export * from "./ExportModalFarmer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports